export const fdw = {
  small: 300,
  medium: 350,
  large: 400,
};

export type IDrawerWidth = keyof typeof fdw | number;
